import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export function formatUtcString(
  value: string,
  formater = 'MM/DD/YYYY HH:mm'
): string {
  return dayjs(value).utc().format(formater)
}

export const Dayjs = dayjs
